import ResizeHelper from '../Modules/_ResizeHelper.js'
import Observer from '../Modules/_Observer.js'

import { select } from 'd3'

class ResponsiveSVG extends Observer {
  create(id) {
    this.wrapper_id = id
    const wrapper = select(this.wrapper_id)
    this.el = wrapper.append('svg')

    this.height = window.innerHeight
    this.width = window.innerWidth
    this.listen()
  }
  listen() {
    new ResizeHelper(e => {
      this.emit('resize')
    })
    this.on('resize', this.resize.bind(this))
  }
  resize() {
    this.width = window.innerWidth
    if (this.width < window.JMOSettings.BREAKPOINT) {
    } else {
      this.height = window.innerHeight
    }
    this.el.attr('width', this.width)
  }
}

export default ResponsiveSVG
